(() => {
  const bindings = new Map();
  function initialize(root = document) {
    root.querySelectorAll('[data-rf-product-details]').forEach(section => {
      if (section.dataset.enhanced) return;
      const tabs = [...section.querySelectorAll('[data-rf-product-tab]')];
      const panels = [...section.querySelectorAll('[data-rf-product-panel]')];
      const controller = new AbortController();
      const options = { signal: controller.signal };
      function select(name, focus = false) {
        tabs.forEach(tab => {
          const active = tab.dataset.rfProductTab === name;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          if (active && focus) tab.focus();
        });
        panels.forEach(panel => { panel.hidden = panel.dataset.rfProductPanel !== name; });
      }
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(tab.dataset.rfProductTab), options);
        tab.addEventListener('keydown', event => {
          const direction = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
          let next = direction ? (index + direction + tabs.length) % tabs.length : null;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== null) {
            event.preventDefault();
            select(tabs[next].dataset.rfProductTab, true);
          }
        }, options);
      });
      section.querySelector('[role=tablist]').hidden = false;
      section.dataset.enhanced = 'true';
      function handleHash() {
        if (location.hash === '#judgeme_product_reviews') {
          select('reviews');
          section.scrollIntoView({ block: 'start', behavior: 'instant' });
        } else if (location.hash === '#ProductDetails') {
          select('description');
        }
      }
      window.addEventListener('hashchange', handleHash, options);
      document.addEventListener('click', event => {
        if (event.target.closest('.jdgm-preview-badge, .jdgm-prev-badge, a[href="#judgeme_product_reviews"]')) select('reviews');
        if (event.target.closest('a[href="#ProductDetails"]')) select('description');
      }, { capture: true, signal: controller.signal });
      bindings.set(section, controller);
      select(location.hash === '#judgeme_product_reviews' ? 'reviews' : 'description');
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    bindings.forEach((controller, section) => {
      if (event.target.contains(section)) { controller.abort(); bindings.delete(section); }
    });
  });
})();
